import styled from 'styled-components'
import { ThemeSelectors, TypeFiesta } from '@at/design-system-foundation'

export const Subtitle = styled(TypeFiesta)`
    font-variation-settings: 'wght' 500;
    font-size: 17px;
    color: ${({ theme }) => theme.color.text.title};
    text-align: left;
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`
